module.exports = __webpack_public_path__ + "static/media/om_beard_long_round__oval_shadow.b7a19fe8.png";